import cx from 'classnames';
import { useReactDndConstructs as useDragAndDropHooks } from '../../dnd/ReactDndContext';
import { DragPreview } from '../../dnd/view/DragPreview';
import { Tile } from './Tile';
import cn from './Tile.css.json';
import './Tile.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const TileDragType = 'NOVA_TILE';
export const TileDragPreview = props => {
  const {
    useDragLayer
  } = useDragAndDropHooks();
  const {
    itemType,
    item
  } = useDragLayer(monitor => ({
    itemType: monitor.getItemType(),
    item: monitor.getItem()
  }));
  if (!item || itemType !== TileDragType || props.dndPrefix !== undefined && item.dndProps?.dndPrefix !== props.dndPrefix) return null;
  const {
    dndProps,
    ...tileProps
  } = item;
  return /*#__PURE__*/_jsx(DragPreview, {
    children: /*#__PURE__*/_jsx(Tile, {
      ...tileProps,
      disableInteractiveMode: true,
      className: cx(tileProps.className, cn.dragPreview)
    })
  });
};
//# sourceMappingURL=TileDragPreview.js.map